// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mjtC","colBig":"styles_colBig__3qHaE","colSmall":"styles_colSmall__26sYn"};